import { createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-0b37449f")

_pushScopeId("data-v-0b37449f")
const _hoisted_1 = { class: "ui__checkDescrip_img" }
const _hoisted_2 = { class: "ui__checkDescrip_tit" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", {
    class: ["ui__checkDescrip", {'noBac': _ctx.state.reportMsg.RpCK()}]
  }, [
    _createVNode("div", _hoisted_1, [
      _createVNode("img", {
        src: _ctx.state.imgSrc
      }, null, 8, ["src"])
    ]),
    (!_ctx.state.reportMsg.RpCK())
      ? (_openBlock(), _createBlock("div", {
          key: 0,
          class: ["ui__checkDescrip_cont", {'nopadding': _ctx.state.nopadding, 'smallpadding': _ctx.state.smallpadding}]
        }, [
          _createVNode("p", _hoisted_2, [
            _createVNode("img", {
              src: _ctx.state.icon
            }, null, 8, ["src"]),
            _createTextVNode("经检测，" + _toDisplayString(_ctx.state.tit), 1)
          ]),
          _createVNode("p", {
            class: ["ui__checkDescrip_txt", {'ui__checkDescrip_txt_more': _ctx.state.content.length>75, 'ui__checkDescrip_txt_all': _ctx.state.contentShowType}]
          }, [
            _createTextVNode(_toDisplayString(_ctx.state.content) + " ", 1),
            _withDirectives(_createVNode("span", {
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.changeShowType && _ctx.changeShowType(...args)))
            }, [
              _createTextVNode(_toDisplayString(_ctx.state.contentShowType ? '收起' : '展开'), 1),
              _createVNode("img", {
                src: require(`@/assets/toc/arrow${_ctx.state.contentShowType ? "Up" : "Down"}Gray.png`)
              }, null, 8, ["src"])
            ], 512), [
              [_vShow, _ctx.state.content.length>75]
            ])
          ], 2)
        ], 2))
      : _createCommentVNode("", true)
  ], 2))
})